/* eslint-disable no-unused-vars */
import { UserIcon } from '@heroicons/react/solid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import logo from '../../components/layout/logo_new.png';
import { forgetAction } from '../../redux/actions/userActions';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const chooseEmail = (e: any) => {
    setEmail(e.target.value);
  };

  const handleFormSubmit = async (e: any) => {
    e.preventDefault();
    await dispatch(forgetAction(email));
    setSubmitted(true);
  };

  return (
    <div className="h-screen flex justify-center items-center bg-login-background bg-cover">
      <div className="flex items-start flex-col  bg-white shadow-lg rounded-2xl border-grey-input_border border-2">
        <div className="flex w-full justify-center p-6 pt-12">
          <Link to={'/login'}>
            <img className="mx-auto w-[200px]" src={logo} />
          </Link>
        </div>

        <form
          onSubmit={handleFormSubmit}
          className=" flex flex-col p-7 space-y-5 min-w-[400px] max-w-[400px]"
        >
          {submitted ? (
            <p className="text-grey-medium">
              Indien dit e-mailadres bij ons bekend is wordt er een link naartoe
              gestuurd om het wachtwoord opnieuw in te stellen.
            </p>
          ) : (
            <>
              <p className="text-sm">
                Vul het e-mailadres van het account in waarvoor u een nieuw
                wachtwoord wil aanvragen.
              </p>

              <div className="flex flex-col space-y-3 relative">
                <label className="text-sm text-grey-medium">Email</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={chooseEmail}
                  className="placeholder-grey-medium text-sm rounded-lg shadow-md border-none py-2 px-3 pl-10"
                  placeholder={t('auth.login_register_enter_email')}
                />
                <UserIcon className="absolute w-5 top-6 left-2" />
              </div>

              <button
                disabled={!email.length}
                type="submit"
                className="rounded-lg group bg-sky text-white px-2 shadow-md py-1 hover:bg-sky-dark disabled:hover:bg-sky hover:shadow-md transition-colors"
              >
                <p>Wachtwoord resetten</p>
              </button>
            </>
          )}

          <Link to="/login" className="flex space-x-1 justify-center w-full">
            <p className="text-sm">Al een account?</p>
            <p className="text-sm text-sky">Klik hier</p>
          </Link>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
